import { Col } from "react-bootstrap"
import styled, { css } from "styled-components"

export const Header = styled.div`
  background: #dce6ea;
  text-align: center;
  padding: 7px 0;
`

export const Table = styled.table`
  font-weight: 0;
  overflow-x: auto;
  color: #545454;
  background-color: #f8fafb !important;
  width: 100%;
  margin-bottom: 0;
`

export const Lente = styled.button`
  border: 0;
  display: block;
  border: 0;
  width: 60px;
  height: 60px;
  color: #fff;
  padding: 15px;
  border-radius: 5px;
  text-decoration: none;
  background-size: 100%;
  cursor: pointer;
  margin: 0 40%;
  background-image: url(${(props) => props.url});
  @media (max-width: 991.98px) {
    margin: 0 0 0 1%;
  }
`

export const TextHeader = styled.p`
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  height: 40px;
  margin: 0;
  color: #000;
  font-weight: 400;
  font-size: 16px;
`

export const IconEdit = styled.a`
  display: block;
  width: 20px;
  height: 20px;
  margin: 0 auto;
  background-image: url("/images/editar.png");
  background-size: contain;
`

export const IconDelete = styled.a`
  display: block;
  width: 20px;
  height: 20px;
  margin: 0 auto;
  background-image: url("/images/excluir.png");
  background-size: contain;
`

export const Td = styled.td`
  vertical-align: middle;
  text-align: center;
  background-color: #f8fafb;
  padding: 7px;
  font-size: 16px;
  border-top: 1px solid #dee2e6;
  ${(props) =>
    props.left
      ? css`
          padding-left: 20px !important;
        `
      : null}
`

export const Th = styled.th`
  padding: 15px;
  vertical-align: middle;
  text-align: center;
  border-bottom: 2px solid #dee2e6;
  font-size: 1.1em;
  line-height: 1.2em;
  font-size: 16px;
  font-weight: 700;
  font-family: "PT Sans", sans-serif;
`

export const PaddingLen = styled(Col)`
  padding: 0.75rem 0.5rem;
`

export const Description = styled.div`
  text-align: center;
  font-size: 16px;
  background: ${(props) => (props.darker ? "#e9eef9" : "#ffffff")};
  padding: ${(props) => (props.isMobile ? "16px" : "5px")};
  .row {
    display: flex;
    align-items: center;
  }
  a {
    color: #2b95ba;
    :hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }
`
export const ShowDetails = styled.div`
  color: #2b95ba;
  :hover {
    cursor: pointer;
    text-decoration: underline;
  }
`
